export const extractTextContent = (component) => {
  // Server-only rendering is not supported in the browser bundle; return safe default.
  return "";
};

export const generateSearchIndex = (routes) => {
  return routes.map((route) => ({
    path: route.path,
    title: route.title,
    content: route.searchContent ?? "",
  }));
};

export const searchContent = (searchTerm, searchIndex) => {
  const term = searchTerm.toLowerCase().trim();

  return searchIndex.filter((item) => {
    const content = item.content.toLowerCase();
    const title = item.title.toLowerCase();
    return content.includes(term) || title.includes(term);
  });
};

export const highlightSearchTerm = (content, term) => {
  const maxLength = 150;
  const termLower = term.toLowerCase();
  const contentLower = content.toLowerCase();
  const index = contentLower.indexOf(termLower);

  if (index === -1) {
    return content.slice(0, maxLength) + "...";
  }

  const start = Math.max(0, index - 60);
  const end = Math.min(content.length, index + 90);
  let preview = content.slice(start, end);

  if (start > 0) preview = "..." + preview;
  if (end < content.length) preview = preview + "...";

  return preview;
};
